/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum PersonFields {
	PersonFirstName = "PersonFirstName",
	PersonSecondNames = "PersonSecondNames",
	PersonLastName = "PersonLastName",
	PersonDateOfBirth = "PersonDateOfBirth",
	PersonLanguage = "PersonLanguage",
	PersonGender = "PersonGender",
	CompanyPersonFirstName = "CompanyPersonFirstName",
	CompanyPersonSecondNames = "CompanyPersonSecondNames",
	CompanyPersonLastName = "CompanyPersonLastName",
	CompanyPersonDateOfBirth = "CompanyPersonDateOfBirth",
	CompanyPersonLanguage = "CompanyPersonLanguage",
	CompanyPersonHomeMunicipality = "CompanyPersonHomeMunicipality",
	CompanyPersonGender = "CompanyPersonGender",
	CompanyPersonEmail = "CompanyPersonEmail",
	CompanyPersonPhone = "CompanyPersonPhone",
	CompanyPersonTitle = "CompanyPersonTitle",
	CompanyPersonIsElectronicCommunicationAllowed = "CompanyPersonIsElectronicCommunicationAllowed",
	CompanyPersonIsInfoUpdateRequestRecipient = "CompanyPersonIsInfoUpdateRequestRecipient",
	CompanyPersonIsActive = "CompanyPersonIsActive",
	CompanyPersonIsVisiblePublicly = "CompanyPersonIsVisiblePublicly",
	CompanyPersonAdditionalInfo = "CompanyPersonAdditionalInfo",
	CompanyPersonPostalAddress = "CompanyPersonPostalAddress",
	CompanyPersonSpecialGroup = "CompanyPersonSpecialGroup",
	StartupperCardIsActive = "StartupperCardIsActive",
	StartupperFirstName = "StartupperFirstName",
	StartupperSecondNames = "StartupperSecondNames",
	StartupperLastName = "StartupperLastName",
	StartupperDateOfBirth = "StartupperDateOfBirth",
	StartupperBirthYear = "StartupperBirthYear",
	StartupperAge = "StartupperAge",
	StartupperLanguageSkills = "StartupperLanguageSkills",
	StartupperCommunicationLanguage = "StartupperCommunicationLanguage",
	StartupperGender = "StartupperGender",
	StartupperEmail = "StartupperEmail",
	StartupperPhone = "StartupperPhone",
	StartupperTitle = "StartupperTitle",
	StartupperIsElectronicCommunicationAllowed = "StartupperIsElectronicCommunicationAllowed",
	StartupperIsContactAdmitAllowed = "StartupperIsContactAdmitAllowed",
	StartupperNationality = "StartupperNationality",
	StartupperPostalAddress = "StartupperPostalAddress",
	StartupperHomeMunicipality = "StartupperHomeMunicipality",
	StartupperAdditionalInfo = "StartupperAdditionalInfo",
	StartupperResponsibleUser = "StartupperResponsibleUser",
	StartupperCountryOfBirth = "StartupperCountryOfBirth",
	UserUsername = "UserUsername",
	UserPassword = "UserPassword",
	UserPhone = "UserPhone",
	UserEmail = "UserEmail",
	UserSecondaryEmail = "UserSecondaryEmail",
	UserIsAdmin = "UserIsAdmin",
	UserIsSuper = "UserIsSuper",
	UserRoles = "UserRoles",
	UserTitle = "UserTitle",
	UserProfilePicture = "UserProfilePicture",
	UserAddress = "UserAddress",
	UserServiceAreas = "UserServiceAreas",
	UserSystemLanguage = "UserSystemLanguage",
	UserUserGroups = "UserUserGroups",
	UserIsActive = "UserIsActive",
	UserCountry = "UserCountry",
	UserServices = "UserServices",
	ImmigrantFirstName = "ImmigrantFirstName",
	ImmigrantLastName = "ImmigrantLastName",
	ImmigrantSecondNames = "ImmigrantSecondNames",
	ImmigrantCardActive = "ImmigrantCardActive",
	ImmigrantElectronicCommunicationAllowed = "ImmigrantElectronicCommunicationAllowed",
	ImmigrantDateOfBirth = "ImmigrantDateOfBirth",
	ImmigrantSocialNumber = "ImmigrantSocialNumber",
	ImmigrantGender = "ImmigrantGender",
	ImmigrantCommunicationLanguage = "ImmigrantCommunicationLanguage",
	ImmigrantPrimaryLanguage = "ImmigrantPrimaryLanguage",
	ImmigrantTranslatorNeed = "ImmigrantTranslatorNeed",
	ImmigrantTranslatorNeedLanguages = "ImmigrantTranslatorNeedLanguages",
	ImmigrantOccupation = "ImmigrantOccupation",
	ImmigrantResponsibleUsers = "ImmigrantResponsibleUsers",
	ImmigrantResidencePermitType = "ImmigrantResidencePermitType",
	ImmigrantCitizenship = "ImmigrantCitizenship",
	ImmigrantBasicInfoLanguageSkills = "ImmigrantBasicInfoLanguageSkills",
	ImmigrantExtraInfo = "ImmigrantExtraInfo",
	ImmigrantUMACustomerNumber = "ImmigrantUMACustomerNumber",
	ImmigrantPhoneNumber = "ImmigrantPhoneNumber",
	ImmigrantEmail = "ImmigrantEmail",
	ImmigrantAddress = "ImmigrantAddress",
	ImmigrantFirstResidenceMunicipality = "ImmigrantFirstResidenceMunicipality",
	ImmigrantFirstResidenceMunicipalityRecordDate = "ImmigrantFirstResidenceMunicipalityRecordDate",
	ImmigrantCurrentResidenceMunicipality = "ImmigrantCurrentResidenceMunicipality",
	ImmigrantCalculatedCompensation = "ImmigrantCalculatedCompensation",
	ImmigrantCalculatedCompensationEndDate = "ImmigrantCalculatedCompensationEndDate",
	ImmigrantArrivalDate = "ImmigrantArrivalDate",
	ImmigrantMunicipalityDecisionDate = "ImmigrantMunicipalityDecisionDate",
	ImmigrantIntegrationPeriod = "ImmigrantIntegrationPeriod",
	ImmigrantIntegrationPeriodStartDate = "ImmigrantIntegrationPeriodStartDate",
	ImmigrantIntegrationPeriodEndDate = "ImmigrantIntegrationPeriodEndDate",
	ImmigrantIntegrationPlanCanBeDone = "ImmigrantIntegrationPlanCanBeDone",
	ImmigrantResidencePermits = "ImmigrantResidencePermits",
	ImmigrantActiveResidencePermit = "ImmigrantActiveResidencePermit",
	ImmigrantTravelDocuments = "ImmigrantTravelDocuments",
	ImmigrantStatus = "ImmigrantStatus",
	ImmigrantMaritalStatus = "ImmigrantMaritalStatus",
	ImmigrantPartnerInfo = "ImmigrantPartnerInfo",
	ImmigrantChildren = "ImmigrantChildren",
	ImmigrantUnderageChildrenExtraInfo = "ImmigrantUnderageChildrenExtraInfo",
	ImmigrantFamilyLeaveAndBenefitInfo = "ImmigrantFamilyLeaveAndBenefitInfo",
	ImmigrantIsNecessaryToMakeFamilyIntegrationPlan = "ImmigrantIsNecessaryToMakeFamilyIntegrationPlan",
	ImmigrantFamilyIntegrationPlanDetails = "ImmigrantFamilyIntegrationPlanDetails",
	ImmigrantSocialNetworks = "ImmigrantSocialNetworks",
	ImmigrantHobbiesOrOrganizationalActivities = "ImmigrantHobbiesOrOrganizationalActivities",
	ImmigrantHasBeenGivenGuidanceForSocialOrOrganizationServices = "ImmigrantHasBeenGivenGuidanceForSocialOrOrganizationServices",
	ImmigrantGuidanceGuidanceExtraInfo = "ImmigrantGuidanceGuidanceExtraInfo",
	ImmigrantOfficerDescriptionOfSkills = "ImmigrantOfficerDescriptionOfSkills",
	ImmigrantSearchProfessions = "ImmigrantSearchProfessions",
	ImmigrantLanguageSkills = "ImmigrantLanguageSkills",
	ImmigrantLanguageSkillsDescription = "ImmigrantLanguageSkillsDescription",
	ImmigrantDrivingLicenseClasses = "ImmigrantDrivingLicenseClasses",
	ImmigrantDrivingLicenseOccupationalCompetence = "ImmigrantDrivingLicenseOccupationalCompetence",
	ImmigrantOwnsCar = "ImmigrantOwnsCar",
	ImmigrantITSkills = "ImmigrantITSkills",
	ImmigrantITSkillsDescription = "ImmigrantITSkillsDescription",
	ImmigrantHobbies = "ImmigrantHobbies",
	ImmigrantWorkExperienceYears = "ImmigrantWorkExperienceYears",
	ImmigrantWorkExperienceDescription = "ImmigrantWorkExperienceDescription",
	ImmigrantWorkExperiences = "ImmigrantWorkExperiences",
	ImmigrantEducationAndQualificationLevels = "ImmigrantEducationAndQualificationLevels",
	ImmigrantEducationDescription = "ImmigrantEducationDescription",
	ImmigrantPermitAndCardTrainings = "ImmigrantPermitAndCardTrainings",
	ImmigrantPermitAndCardTrainingsOccupationalCompetence = "ImmigrantPermitAndCardTrainingsOccupationalCompetence",
	ImmigrantEducationInfos = "ImmigrantEducationInfos",
	JobSeekerFirstName = "JobSeekerFirstName",
	JobSeekerLastName = "JobSeekerLastName",
	JobSeekerSecondNames = "JobSeekerSecondNames",
	JobSeekerCardActive = "JobSeekerCardActive",
	JobSeekerElectronicCommunicationAllowed = "JobSeekerElectronicCommunicationAllowed",
	JobSeekerAllowInformationDisclosure = "JobSeekerAllowInformationDisclosure",
	JobSeekerDateOfBirth = "JobSeekerDateOfBirth",
	JobSeekerSocialNumber = "JobSeekerSocialNumber",
	JobSeekerGender = "JobSeekerGender",
	JobSeekerCommunicationLanguage = "JobSeekerCommunicationLanguage",
	JobSeekerTranslatorNeed = "JobSeekerTranslatorNeed",
	JobSeekerTranslatorNeedLanguages = "JobSeekerTranslatorNeedLanguages",
	JobSeekerOccupation = "JobSeekerOccupation",
	JobSeekerOccupationClassification = "JobSeekerOccupationClassification",
	JobSeekerResponsibleUsers = "JobSeekerResponsibleUsers",
	JobSeekerCitizenship = "JobSeekerCitizenship",
	JobSeekerCustomerGroups = "JobSeekerCustomerGroups",
	JobSeekerPhoneNumber = "JobSeekerPhoneNumber",
	JobSeekerEmail = "JobSeekerEmail",
	JobSeekerAddress = "JobSeekerAddress",
	JobSeekerUnemploymentBenefitType = "JobSeekerUnemploymentBenefitType",
	JobSeekerOfficerDescriptionOfSkills = "JobSeekerOfficerDescriptionOfSkills",
	JobSeekerDescriptionOfSkills = "JobSeekerDescriptionOfSkills",
	JobSeekerSearchProfessions = "JobSeekerSearchProfessions",
	JobSeekerLanguageSkills = "JobSeekerLanguageSkills",
	JobSeekerLanguageSkillsDescription = "JobSeekerLanguageSkillsDescription",
	JobSeekerDrivingLicenseClasses = "JobSeekerDrivingLicenseClasses",
	JobSeekerDrivingLicenseOccupationalCompetence = "JobSeekerDrivingLicenseOccupationalCompetence",
	JobSeekerOwnsCar = "JobSeekerOwnsCar",
	JobSeekerITSkills = "JobSeekerITSkills",
	JobSeekerITSkillsDescription = "JobSeekerITSkillsDescription",
	JobSeekerHobbies = "JobSeekerHobbies",
	JobSeekerWorkExperienceYears = "JobSeekerWorkExperienceYears",
	JobSeekerWorkExperienceDescription = "JobSeekerWorkExperienceDescription",
	JobSeekerWorkExperiences = "JobSeekerWorkExperiences",
	JobSeekerEducationAndQualificationLevels = "JobSeekerEducationAndQualificationLevels",
	JobSeekerEducationDescription = "JobSeekerEducationDescription",
	JobSeekerPermitAndCardTrainings = "JobSeekerPermitAndCardTrainings",
	JobSeekerPermitAndCardTrainingsOccupationalCompetence = "JobSeekerPermitAndCardTrainingsOccupationalCompetence",
	JobSeekerEducationInfos = "JobSeekerEducationInfos",
	JobSeekerExtraInfo = "JobSeekerExtraInfo",
	JobSeekerHealthLimitations = "JobSeekerHealthLimitations",
	JobSeekerSkillwords = "JobSeekerSkillwords",
	LeaderFirstName = "LeaderFirstName",
	LeaderSecondNames = "LeaderSecondNames",
	LeaderLastName = "LeaderLastName",
	LeaderResponsibleUsers = "LeaderResponsibleUsers",
	LeaderDateOfBirth = "LeaderDateOfBirth",
	LeaderPersonalIdentityCode = "LeaderPersonalIdentityCode",
	LeaderAge = "LeaderAge",
	LeaderGender = "LeaderGender",
	LeaderNationality = "LeaderNationality",
	LeaderHomeMunicipality = "LeaderHomeMunicipality",
	LeaderOccupation = "LeaderOccupation",
	LeaderAdditionalInfo = "LeaderAdditionalInfo",
	LeaderCardActive = "LeaderCardActive",
	LeaderElectronicCommunicationAllowed = "LeaderElectronicCommunicationAllowed",
	LeaderContactInformationSharingPermitted = "LeaderContactInformationSharingPermitted",
	LeaderPhoneNumber = "LeaderPhoneNumber",
	LeaderEmail = "LeaderEmail",
	LeaderPostalAddress = "LeaderPostalAddress",
}
